import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/post/post.response.type';
import * as Request from '@shared/models/post/post.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';
import { setPostList, setSinglePost } from '../slices';

export const PostEndpoints = {
    getPostList: config.base_url + '/admin/post',
    getSinglePost: (postId: string) => config.base_url + `/admin/post/${postId}`,
};

export const fetchPostList = createAsyncThunk<void, Request.IFetchPostListQueryType>(
    PostEndpoints.getPostList,
    async (query, { dispatch }) => {
        try {
            const { type, name, limit, offset } = query.params;
            const params = qs.stringify({
                ...(type ? { type: type === 'ALLPOSTS' ? {} : type } : {}),
                ...(name ? { name } : {}),
                limit: limit ? limit : 20,
                offset: offset ? offset : 0,
            });

            const res = await httpService.get<AscResponse<Response.IFetchPostListResponseType>>(
                `${PostEndpoints.getPostList}?${params}`
            );

            dispatch(setPostList(res.data.data));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(formatErrorMessage(err, `Error fetching post list, query: ${PostEndpoints.getPostList}`), {
                type: 'error',
            });
        }
    }
);

export const fetchSinglePost = createAsyncThunk<void, Request.IFetchSinglePostQueryType>(
    PostEndpoints.getSinglePost('id'),
    async (query, { dispatch }) => {
        try {
            const res = await httpService.get<AscResponse<Response.IFetchSinglePostResponseType>>(
                PostEndpoints.getSinglePost(query.params.postId)
            );

            dispatch(setSinglePost(res.data.data));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(formatErrorMessage(err, `Error fetching single post, query: ${PostEndpoints.getSinglePost('id')}`), {
                type: 'error',
            });
        }
    }
);
